export default {
  ourLetter: "Notre lettre",
  restaurantIsClosed: "Le restaurant est fermé",
  isANewProduct: "est un nouveau produit",
  isVegetarian: "est végétarien",
  containsLupin: "Contient du lupin",
  containsCelery: "Contient du céleri",
  containsPeanuts: "Contient des arachides",
  containsCrustacean: "Contient des crustacés",
  containsGluten: "Contient du gluten",
  containsEgg: "Contient de l'oeuf",
  containsMilk: "Contient du lait",
  containsMustard: "Contient de la moutarde",
  containsFish: "Contient du poisson",
  containsSesame: "Contient du sésame",
  containsSoy: "Contient du soja",
  containsSulfite: "Contient du sulfite",
  vegetarian: "Végétarien",
  allergens: "ALLERGÈNES:",
  lupins: "Lupins",
  celery: "Céleri",
  peanuts: "Cacahuètes",
  crustaceans: "Crustacés",
  gluten: "Gluten",
  egg: "Œuf",
  dairyProducts: "Les produits laitiers",
  mustard: "Moutarde",
  fish: "Poisson",
  sesame: "Sésame",
  soy: "Soja",
  sulfite: "sulfite",
  findProduct: "Trouver un produit"
};
